import { AxiosResponse } from "axios";
import simbApi from ".";
import {
  ITEM_LOCATIONS_ENDPOINT,
  DELETE_ALL,
  DELETE,
  UNLINK,
  UNLINK_ITEMS,
  UNLINK_ITEMS_STATUS,
} from "../../data/constants/endpoints";
import logger from "../../lib/logger";
import { TableDataInterface } from "../../components/ItemViewSection/table.data.interface";

interface ApiResponse<T> {
  data: T;
  error?: boolean;
  message?: string;
}

export const getItemLocations = async (
  access_token: string | null,
  itemIdsArray: number[],
  currentBoard: number | null,
  userId: number | string | null,
): Promise<TableDataInterface | null> => {
  try {
    const response = await simbApi.post<ApiResponse<TableDataInterface>>(
      ITEM_LOCATIONS_ENDPOINT,
      {
        itemid: itemIdsArray,
        boardid: currentBoard,
      },
      { headers: { userid: userId, Authorization: `Bearer ${access_token}` } },
    );

    return response?.data?.data;
  } catch (error: any) {
    logger.error(error);
    throw error;
  }
};

export const deleteAllItems = async (access_token: string, itemIds: number[]): Promise<AxiosResponse> => {
  try {
    const response = await simbApi.post(DELETE_ALL, { itemids: itemIds }, { headers: { Authorization: `Bearer ${access_token}` } });

    return response;
  } catch (error: any) {
    logger.log(error.message);
    throw error;
  }
};

export const deleteItem = async (access_token: string, itemId: number, boardId: number): Promise<AxiosResponse> => {
  try {
    const response = await simbApi.post(DELETE, { itemid: itemId, boardid: boardId }, { headers: { Authorization: `Bearer ${access_token}` } });

    return response;
  } catch (error: any) {
    logger.log(error.message);
    throw error;
  }
};

export const unlinkItem = async (access_token: string, itemId: number, boardId: number): Promise<AxiosResponse> => {
  try {
    const response = await simbApi.post(UNLINK, { itemid: itemId, boardid: boardId }, { headers: { Authorization: `Bearer ${access_token}` } });

    return response;
  } catch (error: any) {
    logger.log(error.message);
    throw error;
  }
};

export interface UnlinkItemsQueued {
  requestId: string;
  itemIds: string[];
}

export interface UnlinkItemStatus {
  itemId: string;
  status: "pending" | "done" | "dead";
  error: string | null;
}

/**
 * Batch unlink through orchestration: one request for the whole selection, answered 202 with
 * the requestId its per-item results are keyed on. Throws on anything else, including the 409
 * the backend answers while the orchestrated path is switched off.
 */
export const unlinkItems = async (
  access_token: string,
  itemIds: string[],
): Promise<UnlinkItemsQueued> => {
  const response = await simbApi.post<UnlinkItemsQueued>(
    UNLINK_ITEMS,
    { itemids: itemIds },
    { headers: { Authorization: `Bearer ${access_token}` } },
  );

  return response.data;
};

export const getUnlinkItemsStatus = async (
  access_token: string,
  requestId: string,
): Promise<UnlinkItemStatus[]> => {
  const response = await simbApi.post<{ items: UnlinkItemStatus[] }>(
    UNLINK_ITEMS_STATUS,
    { requestId },
    { headers: { Authorization: `Bearer ${access_token}` } },
  );

  return response.data?.items ?? [];
};
